<template>
  <select-response-auto-complete
    v-bind="$attrs"
    :model="model"
    :getLabel="getLabel"
    searchAllColumns
    api="Forwarders/GetAllDynamic"
    :selected="selected"
    :filters="selectFilters"
    :fields="{id: 'id'}"
    :columns="columns"
    :orderBy="{ fields: 'shipper.shipperName', order: '' }"
    v-on="$listeners"
  >
  </select-response-auto-complete>
</template>

<script>
export default {
  name: 'Index',
  props: {
    model: {
      required: true
    },
    companyID: {
      required: true
    },
    filters: {
      type: String,
      default: 'shipper.shipperName != null'
    }
  },
  computed: {
    selected () {
      return [
        'id', 'accountNumber', 'remarks', 'shipper.shipperName as forwarderShipperName'
      ].join(',')
    },
    columns () {
      return [
        { title: this.L10n('forwarder-shipper-name'), value: 'forwarderShipperName', type: 'string', originField: 'shipper.shipperName' },
        { title: this.L10n('forwarder-account-number'), value: 'accountNumber', type: 'number', originField: 'accountNumber' },
        { title: this.L10n('forwarder-remarks'), value: 'remarks', type: 'string', originField: 'remarks' }
      ]
    },
    selectFilters () {
      const result = []
      const propFilter = this.filters
      const companyFilter = this.companyID ? `companyID == ${this.companyID}` : null
      propFilter && result.push(propFilter)
      companyFilter && result.push(companyFilter)

      return result.join(' && ')
    }
  },
  methods: {
    getLabel (item) {
      let result = []
      item.accountNumber && result.push(item.accountNumber)
      item.forwarderShipperName && result.push(item.forwarderShipperName)
      return result.join(' - ')
    }
  }
}
</script>
